// extracted by mini-css-extract-plugin
module.exports = {"publicWrapper":"Wrapper_publicWrapper__3zUKg"};